import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { routeNames } from "../../routes/routes";
import {
  clearStaleClientCookie,
  getPortalClientLogo,
  getPortalClientUrl,
  isClientBranded,
} from "../../helpers/clientHelper";

// Client logo only: rounded, 44px tall.
// The AssetsWatch logo keeps its normal .nav-logo styling.
const clientLogoStyle = {
  width: "auto",
  height: 44,
  maxWidth: 140,
  objectFit: "contain",
  borderRadius: 12,
};

// Header brand used by both headers (before and after login): only the client's logo
// when the user came from a client site, otherwise just the AssetsWatch logo linking home.
const PortalBrandLogos = () => {
  const { loggedinUser } = useAuth();
  const { pathname } = useLocation();
  // In-app page changes don't reload, so re-check here before reading the client logo.
  clearStaleClientCookie(pathname);
  const clientLogo = getPortalClientLogo(loggedinUser);
  const clientPortalUrl = getPortalClientUrl(loggedinUser);
  const clientBranded = isClientBranded(loggedinUser);

  const logoImg = (
    <img
      className={`nav-logo aw-portal-brand-logo ${
        clientBranded ? "aw-portal-brand-logo-client" : ""
      }`}
      style={clientBranded ? clientLogoStyle : undefined}
      src={clientBranded ? clientLogo : "/assets/images/logo-dark.png"}
      alt={clientBranded ? "Portal" : "AssetsWatch"}
      onError={(e) => {
        if (clientBranded) e.currentTarget.style.display = "none";
      }}
    />
  );

  // Both branding branches use the same outer box so swapping logos cannot
  // change the header's measured height.
  return (
    <div className="navbar-brand aw-portal-brand d-flex align-items-center">
      {clientBranded && clientPortalUrl ? (
        <a
          className="aw-portal-brand-link"
          href={clientPortalUrl}
          onClick={(e) => {
            // Same tab, replacing the current page in history.
            e.preventDefault();
            window.location.replace(clientPortalUrl);
          }}
        >
          {logoImg}
        </a>
      ) : clientBranded ? (
        <span className="aw-portal-brand-link">{logoImg}</span>
      ) : (
        <Link className="aw-portal-brand-link" to={routeNames.home.path}>
          {logoImg}
        </Link>
      )}
    </div>
  );
};

export default PortalBrandLogos;
